import { useState } from 'react';

/**
 * Hooks that abstracts opened state from ConfirmationDialog component
 *
 * @returns {Object}
 */
function useConfirmationDialog({ handleGTMAppointmentTimeSelectedEvent, timestamp, location, showTimeSlots }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    if (timestamp && showTimeSlots) handleGTMAppointmentTimeSelectedEvent(timestamp, location);

    setIsOpen(true);
  };

  return { isOpen, handleOpen, handleClose: () => setIsOpen(false) };
}

export default useConfirmationDialog;
